<script setup>
    const props = defineProps({
        loading: false,
    });

    const emits = defineEmits([ 'click' ]);

    function onClick() {
        emits('click');
    }
</script>

<template>
    <button v-if="!loading" v-bind="$attrs" @click="onClick" class="focus:outline-none transition-all text-sm hover:bg-red border border-red text-red hover:text-white rounded-md px-4 py-2 font-semibold tracking-wide">
        <slot></slot>
    </button>

    <button v-if="loading" v-bind="$attrs" class="focus:outline-none text-sm bg-red border border-red text-white rounded-md px-4 py-2 font-semibold tracking-wide">
        <i class="mr-1 fas fa-spin fa-spinner fa-atom"></i> <slot></slot>
    </button>
</template>
